var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9942 8.32861H10.0025",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9942 11.6599H10.0025",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9942 4.99707H10.0025",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3256 8.32861H13.334",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3256 11.6599H13.334",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3256 4.99707H13.334",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66281 8.32861H6.67114",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66281 11.6599H6.67114",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66281 4.99707H6.67114",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49567 18.3226V15.8241C7.49567 15.6032 7.58341 15.3913 7.7396 15.2351C7.89579 15.079 8.10763 14.9912 8.32852 14.9912H11.6599C11.8808 14.9912 12.0926 15.079 12.2488 15.2351C12.405 15.3913 12.4928 15.6032 12.4928 15.8241V18.3226",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9913 1.66577H4.99709C4.07715 1.66577 3.33139 2.41153 3.33139 3.33147V16.6571C3.33139 17.577 4.07715 18.3228 4.99709 18.3228H14.9913C15.9112 18.3228 16.657 17.577 16.657 16.6571V3.33147C16.657 2.41153 15.9112 1.66577 14.9913 1.66577Z",
    stroke: "#0A3D78",
    strokeWidth: 1.6657,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderInfo);
export default __webpack_public_path__ + "static/media/headerInfo.d8fe12716f0404d35187056140f9411a.svg";
export { ForwardRef as ReactComponent };